import endpoints from '../endpoints.ts';
import { QuarantineStatusEnum, QuarantineStatusAction } from '../enums.ts';
import {
  HydratedQuarantineFoundMeds,
  HydratedQuarantine,
} from '../types/compoundModels.ts';
import { ScannedBarcodeData, Toast } from '../types/models.ts';
import { WithPagination } from '../types/types.ts';
import { fetch } from './helpers.ts';
import { MedAPI } from './med.ts';

const med = {
  create: {
    one: {
      quarantine: async (
        quarantine: ScannedBarcodeData & {
          customerLocationId?: number | string;
          note: string;
        }
      ) => {
        const url = endpoints.quarantine.create.one.quarantine();
        return await fetch<Toast>(url, 'POST', quarantine);
      },
      status: async (statusInfo: {
        status: QuarantineStatusEnum;
        action: QuarantineStatusAction;
        note: string;
        quarantineId: number;
        force?: boolean;
      }) => {
        const url = endpoints.quarantine.create.one.status();
        return await fetch<Toast>(url, 'POST', statusInfo);
      },
    },
  },
  read: {
    count: async () => {
      const url = endpoints.quarantine.read.count();
      return await fetch<number>(url, 'GET');
    },
    many: {
      by: {
        customerLocationId: async (params: {
          customerLocationIds: number[];
        }) => {
          const url = endpoints.quarantine.read.many.by.customerLocationId();
          return await fetch<HydratedQuarantineFoundMeds[] | null>(
            url,
            'GET',
            params
          );
        },
        search: async (params: Partial<MedAPI.Request.ReadManyBySearch>) => {
          const url = endpoints.quarantine.read.many.by.search();
          return await fetch<WithPagination<HydratedQuarantine>>(url, 'GET', {
            ...params.values,
            ...params.paginationOptions,
          });
        },
      },
    },
  },
  update: {
    many: {
      by: {
        id: async (params: {
          meds: {
            quarantineId: string | number;
            epcisSgtinId: string | number;
          }[];
        }) => {
          const url = endpoints.quarantine.update.many.by.id();
          return await fetch<Toast | null>(url, 'POST', params);
        },
      },
    },
  },
};

export default med;
